// Reglas de validacion compartidas. Centralizar acá los regex y los checks
// evita que cada formulario reescriba su propia version.

export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
export const DNI_LENGTH = 8

export interface PasswordValidation {
  length: boolean
  lowercase: boolean
  uppercase: boolean
  number: boolean
  specialChar: boolean
}

export const PASSWORD_RULES = {
  minLength: 8,
  specialChars: "-_@$!%*?&",
} as const

export const validateEmail = (email: string): boolean => EMAIL_REGEX.test(email)

export const validateDniFormat = (dni: string | number): boolean =>
  String(dni).length === DNI_LENGTH

export const validatePassword = (password: string): PasswordValidation => ({
  length: password.length >= PASSWORD_RULES.minLength,
  lowercase: /[a-z]/.test(password),
  uppercase: /[A-Z]/.test(password),
  number: /\d/.test(password),
  specialChar: /[-_@$!%*?&]/.test(password),
})

export const isPasswordValid = (validation: PasswordValidation): boolean =>
  validation.length &&
  validation.lowercase &&
  validation.uppercase &&
  validation.number &&
  validation.specialChar

export const normalizeString = (str: string): string =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
